import {combineReducers} from 'redux';
import organization from './organization.reducer';

const organizationReducer = combineReducers({
	organization,
});

export default organizationReducer;